import React from 'react'
import { Modal, ModalHeader, ModalBody } from "reactstrap";

export default function KnowMorwOfPoints({ showKnowMoremodal, toggleKnowMore }) {

  return (
    <>
      <Modal className='addnew_route modal-dialog-centered' isOpen={showKnowMoremodal} toggle={toggleKnowMore}>
        <ModalHeader toggle={toggleKnowMore}>
        </ModalHeader>
        <ModalBody>
          <p>
            One of the biggest issues when traveling to הקדשים מקומות is trying to find the fastest most efficient
            route - hitting as many places as possible with the
            best use of time.<br></br>
            Nesiya Tova is thrilled to announce that we are
            currently added a new feature that will be able to
            automatically optimize your route.<br></br>
            You'll be able to hit a button that will re-arrange your
            current route and put it into the most optimal time efficient order.<br></br>
            The option is available in the route list by pressing the left bottom button "Optimize".
          </p>
        </ModalBody>
      </Modal>
    </>
  )
}
